import { useContext, useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { SidebarContext } from 'context/SidebarContext';
import SoldOutServices from 'services/SoldOutServices';
import { notifyError, notifySuccess } from 'utils/toast';

const useSoldOutSubmit = (id, packageCityPairs, setPackageCityPairs) => {
	const { isDrawerOpen, closeDrawer, setIsUpdate } = useContext(SidebarContext);
	const [isSubmitting, setIsSubmitting] = useState(false);
	const [serviceType, setServiceType] = useState(null);
	const [selectedCity, setSelectedCity] = useState();
	const [packageType, setPackageType] = useState();
	const [startDate, setStartDate] = useState(null);
	const [endDate, setEndDate] = useState(null);
	const [vehicleType, setVehicleType] = useState();
	const parseDate = (dateString) => {
		const [day, month, year] = dateString.split('-').map(Number);
		return new Date(year, month - 1, day); // Month is 0-based in JS Date
	};
	const [loading, setLoading] = useState(false);
	const {
		register,
		handleSubmit,
		setValue,
		clearErrors, 
		trigger,
		formState: { errors },
	} = useForm();

	const onSubmit = async (data) => {
		setLoading(true);
		try {
			setIsSubmitting(true);

			const VehicleCategoryData = {
				service_type: serviceType,
				data: packageCityPairs,
				package_type: packageType,
				vehicle_type: vehicleType.map((item) => item.value),
				start_date: new Date(startDate)
					.toLocaleDateString('en-GB')
					.split('/')
					.join('-'),
				end_date: new Date(endDate)
					.toLocaleDateString('en-GB')
					.split('/')
					.join('-'),
			};

			if (id) {
				const res = await SoldOutServices.updateSoldOut(
					id,
					VehicleCategoryData
				);
				setIsUpdate(true);
				setIsSubmitting(false);
				notifySuccess(res.message);
				closeDrawer();
			} else {
				const res = await SoldOutServices.addSoldOut(VehicleCategoryData);
				setIsUpdate(true);
				setIsSubmitting(false);
				notifySuccess(res.message);
				closeDrawer();
			}
		} catch (err) {
			notifyError(err ? err?.response?.data?.message : err?.message);
			setIsSubmitting(false);
			// closeDrawer();
		} finally {
			setLoading(false);
		}
	};

	const getVehicleCategoryData = async () => {
		try {
			const res = await SoldOutServices.getSoldOutById(id);
		if (res) {
			const data = res.data;

			// Parse vehicle types
			const vehicle_type = data.vehicle_type.map((id) => ({
				value: Number(id),
				label: data.vehicle_type_names[id],
			}));

			const cityNames = data.city_name.split(',').map((name) => name.trim());

const selectedCity = data.city.map((cityId, index) => ({
	value: cityId,
	label: cityNames[index],
}));


			// Set all form states
			setServiceType(data.service_type);
			setPackageType(data.package_type);
			setSelectedCity(selectedCity);
			setStartDate(parseDate(data.start_date));
			setEndDate(parseDate(data.end_date));
			setVehicleType(vehicle_type);

			// 💡 Important: Update `packageCityPairs` here
			setPackageCityPairs([
				{
					packageType: data.package_type,
					selectedCity: selectedCity,
				},
			]);
		}
	} catch (err) {
		closeDrawer();
		notifyError(err ? err?.response?.data?.message : err?.message);
	}
	};

	useEffect(() => {
		if (!isDrawerOpen) {
			setValue('vehicle_type');
			setVehicleType(null);
			clearErrors();
			return;
		}

		if (id) {
			getVehicleCategoryData();
		} else {
			setServiceType();
			setPackageType();
			setSelectedCity();
			setStartDate();
			setEndDate();
			setPackageCityPairs([
				{ packageType: null, selectedCity: null },
			]);
			setValue('vehicle_type');
			setVehicleType(null);
			clearErrors();
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [id, setValue, isDrawerOpen, clearErrors]);

	return {
		register,
		handleSubmit,
		trigger,
		onSubmit,
		errors,
		isSubmitting,
		loading,
		setLoading,
		setServiceType,
		serviceType,
		setSelectedCity,
		selectedCity,
		packageType,
		setPackageType,
		startDate,
		endDate,
		setEndDate,
		setStartDate,
		vehicleType,
		setVehicleType,
	};
};

export default useSoldOutSubmit;
